import type { LatLong } from '@iheartjane/geolocation';

import type { BloomMenuStore } from '@jane/bloom/types/schemas/roots/bloom/menu';
import { getDistance } from '@jane/bloom/utils/geo/getDistance';

/**
 * Sort the array according to the user's lat long
 * @param searchLocation {LatLong} - User's latitude and longitude
 * @param locations {Array} - Array of objects that contain latitude and longitude
 * @returns {Array} - Sorted array of locations in ascending order, with recreational stores prioritized when distances are equal
 * @see https://github.com/yousufkalim/nearby-sort for the original implementation.
 */
export function nearbySort(
  { lat, long }: LatLong,
  locations: BloomMenuStore[]
): BloomMenuStore[] {
  // Clone locations to leave the original sort order unchanged
  return [...locations].sort((a, b) => {
    const distanceA = getDistance(lat, long, a.latitude, a.longitude);
    const distanceB = getDistance(lat, long, b.latitude, b.longitude);
    const distanceDiff = distanceA - distanceB;

    // If distances are essentially equal, prioritize recreational stores
    if (Math.abs(distanceDiff) < 0.001) {
      const aRec = a.recreational;
      const bRec = b.recreational;

      if (aRec === true && bRec === false) return -1;
      if (aRec === false && bRec === true) return 1;
    }

    return distanceDiff;
  });
}
